/* The brand's full lockup as data, drawn by two hands: `VoleeLockup` in the page, and the Vite plugin
   that writes the boot screen into index.html at build time, before any bundle (vite.boot-screen.mjs).
   Plain JS so that Node can read it too: one vector, never a copy retyped by hand. */

export const LOCKUP_VIEW_BOX = '267 236 649 265'

/** The name and «FOOTBALL»: the island's white. */
export const LOCKUP_NAME = [
  {
    d: 'M 608.8 367.6 C 593.6 367.6 581.3 353.8 581.3 336.8 C 581.3 319.8 593.6 306 608.8 306 C 624 306 636.3 319.8 636.3 336.8 C 636.3 353.8 624 367.6 608.8 367.6 M 609 292 C 585.4 292 567.3 311.9 567.3 336.5 C 567.3 361.1 585.4 381.2 609 381.2 C 632.7 381.2 650.2 360.9 650.2 336.3 C 650.2 311.6 632.7 292 609 292',
  },
  {
    d: 'M 678.3 293.6 L 678.3 380.2 L 738.8 380.2 L 738.8 367.1 L 692.9 367.1 L 692.9 293.6 Z M 678.3 293.6',
  },
  {
    d: 'M 850.9 293.4 L 850.9 379.4 L 910.9 379.4 L 910.9 366.9 L 864.5 366.9 L 864.5 340.3 L 903.6 340.3 L 903.6 329.9 L 864 329.9 L 864 305.9 L 908.8 305.9 L 908.8 293.9 Z M 850.9 293.4',
  },
  {
    d: 'M 462.7 293.4 L 478 293.4 L 507.4 362.2 L 536.4 293.4 L 552.2 294.2 L 517.4 379.6 L 500 379.6 Z M 462.7 293.4',
  },
  {
    transform: 'translate(556.4058 426.542)',
    d: 'M 17.6 -18.8 L 17.6 -20.9 L 3 -20.9 L 3 0 L 6.1 0 L 6.1 -9.7 L 16.6 -9.7 L 16.6 -11.9 L 6.1 -11.9 L 6.1 -18.8 Z M 17.6 -18.8',
  },
  {
    transform: 'translate(585.74 426.542)',
    d: 'M 13.8 -21.2 C 16.2 -21.2 18.3 -20.7 20.1 -19.8 C 21.8 -18.9 23.2 -17.7 24.1 -16.1 C 25.1 -14.4 25.6 -12.5 25.6 -10.5 C 25.6 -8.4 25.1 -6.5 24.1 -4.8 C 23.2 -3.3 21.8 -2 20.1 -1.1 C 18.3 -0.2 16.2 0.3 13.8 0.3 C 11.3 0.3 9.2 -0.2 7.5 -1.1 C 5.8 -2 4.4 -3.3 3.5 -4.8 C 2.5 -6.3 2 -8.2 2 -10.5 C 2 -12.7 2.5 -14.6 3.5 -16.1 C 4.4 -17.7 5.8 -18.9 7.5 -19.8 C 9.2 -20.7 11.3 -21.2 13.8 -21.2 Z M 13.8 -1.9 C 15.7 -1.9 17.2 -2.3 18.4 -3.1 C 19.5 -3.8 20.5 -4.8 21.2 -6.1 C 21.9 -7.4 22.3 -8.8 22.3 -10.5 C 22.3 -12.1 21.9 -13.5 21.2 -14.8 C 19.6 -17.6 17.2 -19 13.8 -19 C 11.9 -19 10.4 -18.6 9.2 -17.8 C 8 -17.1 7.1 -16.1 6.4 -14.8 C 5.7 -13.6 5.3 -12.2 5.3 -10.5 C 5.3 -8.7 5.7 -7.3 6.4 -6.1 C 7.1 -4.8 8 -3.8 9.2 -3.1 C 10.4 -2.3 11.9 -1.9 13.8 -1.9 Z M 13.8 -1.9',
  },
  {
    transform: 'translate(623.3643 426.542)',
    d: 'M 13.8 -21.2 C 16.2 -21.2 18.3 -20.7 20.1 -19.8 C 21.8 -18.9 23.2 -17.7 24.1 -16.1 C 25.1 -14.4 25.6 -12.5 25.6 -10.5 C 25.6 -8.4 25.1 -6.5 24.1 -4.8 C 23.2 -3.3 21.8 -2 20.1 -1.1 C 18.3 -0.2 16.2 0.3 13.8 0.3 C 11.3 0.3 9.2 -0.2 7.5 -1.1 C 5.8 -2 4.4 -3.3 3.5 -4.8 C 2.5 -6.3 2 -8.2 2 -10.5 C 2 -12.7 2.5 -14.6 3.5 -16.1 C 4.4 -17.7 5.8 -18.9 7.5 -19.8 C 9.2 -20.7 11.3 -21.2 13.8 -21.2 Z M 13.8 -1.9 C 15.7 -1.9 17.2 -2.3 18.4 -3.1 C 19.5 -3.8 20.5 -4.8 21.2 -6.1 C 21.9 -7.4 22.3 -8.8 22.3 -10.5 C 22.3 -12.1 21.9 -13.5 21.2 -14.8 C 19.6 -17.6 17.2 -19 13.8 -19 C 11.9 -19 10.4 -18.6 9.2 -17.8 C 8 -17.1 7.1 -16.1 6.4 -14.8 C 5.7 -13.6 5.3 -12.2 5.3 -10.5 C 5.3 -8.7 5.7 -7.3 6.4 -6.1 C 7.1 -4.8 8 -3.8 9.2 -3.1 C 10.4 -2.3 11.9 -1.9 13.8 -1.9 Z M 13.8 -1.9',
  },
  {
    transform: 'translate(660.9886 426.542)',
    d: 'M 0.4 -18.8 L 8.7 -18.8 L 8.7 0 L 11.7 0 L 11.7 -18.8 L 20.1 -18.8 L 20.1 -20.9 L 0.4 -20.9 Z M 0.4 -18.8',
  },
  {
    transform: 'translate(691.55265 426.542)',
    d: 'M 15.5 -11.5 C 16.6 -11.9 17.4 -12.5 17.9 -13.4 C 18.5 -14.2 18.8 -15 18.8 -16 C 18.8 -17.5 18.2 -18.7 17 -19.6 C 15.9 -20.5 14.1 -20.9 11.9 -20.9 L 3 -20.9 L 3 0 L 11.2 0 C 12.8 0 14.2 -0.2 15.5 -0.5 C 16.8 -0.8 17.9 -1.3 18.8 -1.9 C 19.5 -2.5 20.1 -3.1 20.4 -3.9 C 20.7 -4.7 20.9 -5.5 20.9 -6.4 C 20.9 -7.6 20.4 -8.8 19.3 -9.8 C 18.3 -10.7 17.1 -11.3 15.5 -11.5 Z M 15.9 -15.8 C 15.9 -13.4 13.8 -12.2 9.4 -12.2 L 6.1 -12.2 L 6.1 -18.8 L 10.9 -18.8 C 12.5 -18.8 13.8 -18.5 14.6 -18.1 C 15.5 -17.6 15.9 -16.9 15.9 -15.8 Z M 17.9 -6.1 C 17.9 -4.8 17.3 -3.8 16 -3.1 C 15 -2.5 13.5 -2.2 11.7 -2.2 L 6.1 -2.2 L 6.1 -10.1 L 10.4 -10.1 C 12.5 -10.1 14.2 -9.9 15.4 -9.4 C 17.1 -8.8 17.9 -7.7 17.9 -6.1 Z M 17.9 -6.1',
  },
  {
    transform: 'translate(724.25755 426.542)',
    d: 'M 12.9 -20.9 L 9.3 -20.9 L 0.7 0 L 3.9 0 L 6.2 -6.1 L 15.8 -6.1 L 18.2 0 L 21.5 0 Z M 14.9 -8.3 L 7.1 -8.3 L 11 -18.3 Z M 14.9 -8.3',
  },
  {
    transform: 'translate(756.50695 426.542)',
    d: 'M 3 0 L 17.3 0 L 17.3 -2.2 L 6.1 -2.2 L 6.1 -20.9 L 3 -20.9 Z M 3 0',
  },
  {
    transform: 'translate(784.74795 426.542)',
    d: 'M 3 0 L 17.3 0 L 17.3 -2.2 L 6.1 -2.2 L 6.1 -20.9 L 3 -20.9 Z M 3 0',
  },
]

/** The É and its accent: the lime, standing still. */
export const LOCKUP_ACCENT = [
  'M 762.7 293.6 L 762.7 379.6 L 822.7 379.6 L 822.7 367.1 L 776.3 367.1 L 776.3 340.5 L 815.4 340.5 L 815.4 330.1 L 775.8 330.1 L 775.8 306.1 L 820.6 306.1 L 820.6 294.1 Z M 762.7 293.6',
  'M 784.6 286.3 L 798.2 286.3 L 814.3 270.2 L 797.1 270.2 Z M 784.6 286.3',
]

/* Each stripe of the V with the place it takes in the opening (`--r`), which delays it. Which of
   the V's strokes are stripes is the artwork's. */
export const LOCKUP_STRIPES = [
  [
    1,
    'M 273.4 241 C 332.5 237.5 377.4 251.5 383 262.7 C 383 262.8 383 262.8 383 262.8 C 354.2 251.1 321.2 246.2 281.6 251.5 C 277.2 252.2 272.9 249.5 271.4 245.2 L 271.1 244.4 C 270.6 242.8 271.7 241.1 273.4 241',
  ],
  [
    2,
    'M 285.5 263.6 C 338.5 260.9 372.4 268.8 393.1 284 C 393.4 284.2 393.2 284.6 392.9 284.5 C 364.7 273.4 332.3 268.8 293.7 274 C 289.3 274.6 285 272 283.6 267.8 L 283.3 266.9 C 282.8 265.4 283.9 263.7 285.5 263.6',
  ],
  [
    3,
    'M 295.3 285.3 C 349.8 282.3 378.9 286.7 401.3 305.4 C 401.3 305.5 401.3 305.6 401.2 305.6 C 368.7 293.6 337.4 292.6 303.6 296.1 C 298.9 296.6 294.6 293.4 293.1 288.9 L 293.1 288.7 C 292.5 287.1 293.6 285.4 295.3 285.3',
  ],
  [
    4,
    'M 305.6 307.8 C 358.6 305.2 388.5 311 408.8 325.7 C 408.9 325.8 408.8 325.9 408.7 325.9 C 376.3 314.4 346.6 315.9 313.7 317.5 C 309.3 317.7 305.1 315.6 303.7 311.6 L 303.4 310.9 C 302.9 309.4 304 307.9 305.6 307.8',
  ],
  [
    5,
    'M 315.9 329.2 C 370.2 326.4 396.6 330.6 417.4 346.2 C 417.6 346.4 417.5 346.6 417.2 346.6 C 382.8 335.4 357.9 338 323.4 339.8 C 319.2 340 315.3 337.4 313.9 333.4 L 313.6 332.5 C 313 330.9 314.2 329.3 315.9 329.2',
  ],
  [
    6,
    'M 327.3 351.2 C 381.2 348.6 407.3 352.5 427.9 367.1 C 428.1 367.2 428 367.5 427.7 367.4 C 393.6 357 369 359.4 334.8 361.1 C 330.6 361.3 326.8 358.9 325.4 355.1 L 325.1 354.3 C 324.6 352.9 325.7 351.3 327.3 351.2',
  ],
  [
    7,
    'M 338.6 372.3 C 376.6 368.9 405.8 372.9 429 382 C 461.6 373.3 483 371.8 513.6 371.4 C 515 371.4 516.1 372.7 515.9 374.1 L 515.4 380 C 515.1 382.8 514.1 384.7 510.7 384.5 C 492.8 381.3 466.2 381.5 429.2 384.2 C 400.3 382.5 340.8 383.4 338.3 382 C 337.3 381.6 336.7 380.7 336.4 379.7 L 336 378 C 335.3 375.9 336.4 372.1 338.6 372.3',
  ],
  [
    1,
    'M 569.1 241.7 C 510 238.2 483.9 251.2 475.1 259.3 C 475.1 259.4 475.1 259.4 475.1 259.3 C 503.9 247.7 521.3 246.9 560.8 252.3 C 565.3 252.9 569.6 250.2 571 245.9 L 571.3 245.1 C 571.9 243.5 570.7 241.8 569.1 241.7',
  ],
  [
    2,
    'M 560 261.5 C 502.7 260.1 475.7 269.3 468.7 277.5 C 468.6 277.5 468.6 277.5 468.7 277.5 C 496.1 266.3 526 267.5 552.3 271 C 556.6 271.6 560.7 268.9 562 265.1 L 562.2 264.4 C 562.7 262.9 561.6 261.5 560 261.5',
  ],
  [
    6,
    'M 501.3 355.4 C 467.7 346.3 439.1 360.4 434.2 365.7 C 433.9 366 433.7 365.8 434.2 365.7 C 463.3 359.2 466.8 360.6 493.3 360.3 C 497.7 360.3 501.6 362.9 503.1 359.1 L 503.4 358.4 C 504 357 502.9 355.8 501.3 355.4',
  ],
  [
    8,
    'M 352.5 394.8 C 387.7 392.9 397.4 394.7 431.7 396.7 C 464.6 394.1 478.1 394.3 505.2 393.8 C 506.4 393.8 507.8 393.8 507.7 395.2 C 507.7 395.2 507 403.4 506.6 404 C 506.3 404.6 505.2 404.9 504.5 404.9 C 486.2 404.2 465.7 402.3 432.6 403.7 C 405.9 401.7 355.8 405.5 352.2 405 C 351.3 404.9 350.8 403.5 350.6 402.5 L 350.2 400.8 C 349.6 398.5 350.5 394.5 352.5 394.8',
  ],
  [
    9,
    'M 363.4 417.2 C 363.7 416.8 364.2 416.6 364.7 416.5 C 394 414.9 403.7 416.2 433.1 416 C 461.7 415.4 471.3 417.4 494.2 416.3 C 497.1 416.1 495.9 425.5 494.2 425.6 C 478.6 424.9 462.4 423.9 434.2 424.2 C 411.4 424.4 377.1 426 364.3 425.4 C 363.6 425.4 361.5 420.4 363.4 417.2',
  ],
  [
    10,
    'M 377.9 436 L 478.8 436 C 480.1 436 481.7 436.6 481.9 437.8 C 482.2 441.3 481.1 444.5 478.5 445 L 378.3 445.1 C 374.4 444.1 374.6 437.5 377.1 436.1 C 377.4 436 377.7 436 377.9 436',
  ],
  [
    11,
    'M 398.3 454.7 L 463.2 454.6 C 464 454.6 464.7 455 465.1 455.7 C 466.8 459.1 467.4 461.4 464.6 464.8 C 463.7 465.9 461.7 466.4 460.4 466.4 L 399.3 466.8 C 397.9 466.8 396.1 466.1 395.3 465 C 392.9 461.7 393.3 459.5 395.1 456.5 C 395.8 455.4 397 454.7 398.3 454.7',
  ],
  [
    11,
    'M 444 483.7 C 444 490.4 438.6 495.9 431.8 495.9 C 425.1 495.9 419.6 490.4 419.6 483.7 C 419.6 476.9 425.1 471.5 431.8 471.5 C 438.6 471.5 444 476.9 444 483.7',
  ],
  [
    3,
    'M 454.2 302.9 C 454.3 302.7 459.1 296.9 459.5 297.3 C 459.9 297.6 462.4 299.8 461.9 300.3 C 461.5 300.8 454 303.1 454.2 302.9',
  ],
  [
    4,
    'M 447.9 325 C 448.1 324.8 462.2 315 462.9 315.4 C 463.6 315.8 466.1 319 465.4 319.4 C 464.7 319.8 447.7 325.2 447.9 325',
  ],
  [
    5,
    'M 441.6 346 C 442 345.7 468.5 332 469.8 332.5 C 471.1 333 475.9 337.5 474.5 338.1 C 473.1 338.7 441.2 346.3 441.6 346',
  ],
]
